// import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Chart } from 'chart.js/auto';
// import { MapService } from '../../services/map.service';
// import Graphic from '@arcgis/core/Graphic';
// import FeatureTable from '@arcgis/core/widgets/FeatureTable';
// import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
// import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
// import StatisticDefinition from '@arcgis/core/rest/support/StatisticDefinition';
// import Query from '@arcgis/core/rest/support/Query';

// @Component({
//   selector: 'app-plan-dashboard',
//   templateUrl: './plan-dashboard.component.html',
//   styleUrl: './plan-dashboard.component.scss'
// })
// export class PlanDashboardComponent implements OnInit, AfterViewInit{

//   public planFieldNames:any[];
//    selectionIdCount = 0; // The filtered selection id count
//    candidate; // The graphic accessed via the view.click event
//   selectedBaladeya:string="";
//   selectedZoneCode:string="";
//   query;
//   layer;
//   newChart;
//   // indx:number=0;
//   constructor(private http: HttpClient, private mapService: MapService, private elementRef: ElementRef) { }

//   ngOnInit() {

// this.planFieldNames = ['parcel_plane','Correction_Parcel','MadinahAerialPhotography_zone','Comparison','Plan_Correct','Zoon_Code','Balady_2','F3D','BELEDIYE'];
// const url = 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5';

//   this.layer = new FeatureLayer({
//     url: url
//   });

//   // const fieldNames = ['parcel_plane', 'Correction_Parcel', 'MadinahAerialPhotography_zone', 'Comparison', 'Plan_Correct', 'Zoon_Code', 'Balady_2', 'F3D','BELEDIYE'];
//   // const fieldNames1 = ['objectid'];

// var indx = 0;
//   // if (!this.selectedBaladeya && !this.selectedZoneCode){
//   this.planFieldNames.forEach(((field)=>{
//     //debugger;
//      this.query = this.layer.createQuery();

//     const statisticDefinitions =  new StatisticDefinition({
//       onStatisticField: 'objectid',
//       outStatisticFieldName: field+'_C',
//       statisticType: 'count'
//     });

//      // Add filter conditions based on selected values
//      if (field === 'BELEDIYE' && this.selectedBaladeya) {
//       this.query.where = `BELEDIYE = '${this.selectedBaladeya}'`;
//     } else if (field === 'Zoon_Code' && this.selectedZoneCode) {
//       this.query.where = `Zoon_Code = '${this.selectedZoneCode}'`;
//     }

//     this.query.outStatistics = [statisticDefinitions];
//     this.query.returnGeometry = false;
//     //query.where = '1=1';
//     this.query.groupByFieldsForStatistics =  [field];

//     var that = this;
//   this.layer.queryFeatures(this.query).then(function (result)  {
//     //  debugger;
//     console.log(result);
//     let stats = result.features[0].attributes;
//      console.log("output stats:", stats);
//     const features = result && result.features ? result.features : [];
//     // Process the retrieved features and create charts
//     // console.log('hello features');
//     // console.log(features);
//     indx++;
//     if (features) {
//       that.createCharts(result, indx);

// console.log(features[0].attributes);
//       // this.createChart(canvasId, chartData, chartTitle, legendLabels,fieldName);

//     } else {
//       console.error('No features found.');
//     }
//   })
//   .catch(function (error)  {
//     console.error('Error fetching features:', error);
//   });
// }));

// // }

// }

// // processFeatures(features, indx) {

// //   if (features) {
// //     // const fieldCounts = {};

// //     // features.forEach((feature) => {
// //     //   debugger;
// //     //   this.planFieldNames.forEach(function (fieldName)  {
// //     //     debugger;
// //     //     const fieldValue = feature.attributes[fieldName];
// //     //     if (!fieldCounts[fieldName]) {
// //     //       fieldCounts[fieldName] = {};
// //     //     }
// //     //     fieldCounts[fieldName][fieldValue] = (fieldCounts[fieldName][fieldValue] || 0) + 1;
// //     //   });
// //     // });

// //     // Create charts using fieldCounts object

// //     this.createCharts(features, indx);
// //   } else {
// //     console.error('No features found.');
// //   }
// // }

// createCharts(features: any, indx) {
//   features.fields.forEach( (fieldName, index) => {
//     console.log(features.features.map(f=> f.attributes));

//     if (index==0) {
//       const canvasId = `MyChart${indx}`;
//       const chartData = features.features.map(f=> f.attributes);//fieldCounts[fieldName];
//       const chartTitle = fieldName.name;
//       const legendLabels =  features.features.map(f=> f.attributes[fieldName.name]);//Object.keys(chartData);
//   // alert(canvasId);
//       this.createChart(canvasId, chartData, chartTitle, legendLabels,fieldName);//fieldName

//     }

//   });
// }

// ngAfterViewInit(): void {
//   const url =
//     'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5';
//   const fields = [
//     'parcel_plane',
//     'correction_Parcel',
//     'MadinahAerialPhotography_zone',
//     'Plan_Correct',
//     'Zoon_Code',
//     'Comparison',
//     'Balady_2',
//     'F3D',
//     'BELEDIYE'
//   ];

//   this.createAttributeTable(url, fields);
// }

// createAttributeTable(url: string, fields: string[]) {

//   const container = this.elementRef.nativeElement.querySelector(
//     '.attributeContent'
//   );

//   const layer = new FeatureLayer({
//     url: url,
//     outFields: fields
//   });

//   this.mapService.mapView.when(() => {
//   const featureTable = new FeatureTable({
//     view: this.mapService.mapView, // Replace with your MapView instance
//     layer: layer,
//     container: container,
//     visibleElements: {
//       // Autocast to VisibleElements
//       menuItems: {
//         clearSelection: true,
//         refreshData: true,
//         toggleColumns: true,
//         selectedRecordsShowAllToggle: true,
//         zoomToSelection: true
//       }
//     },
//     editingEnabled: true,
//     tableTemplate: { // autocast to TableTemplate
//       columnTemplates: [ // takes an array of GroupColumnTemplate and FieldColumnTemplate
//         // { // autocast to GroupColumnTemplate
//           // type: "group",
//           // label: "Parcel details",
//           // columnTemplates: [
//               {
//                 type: "field",
//                 fieldName: "OBJECTID",
//                 label: "OBJECTID"
//               },
//               {
//                 type: "field",
//                 fieldName: "parcel_plane",
//                 label: "رسم المخطط"
//               },
//               {
//                 type: "field",
//                 fieldName: "correction_Parcel",
//                 label: "تصحيح الأراضي"
//               },
//               {
//                 type: "field",
//                 fieldName: "MadinahAerialPhotography_zone",
//                 label: "مرحلة العمل بالتصوير الجوي"
//               },
//               {
//                 type: "field",
//                 fieldName: "Plan_Correct",
//                 label: "مرحلة تصحيح المخطط"
//               },
//               {
//                 type: "field",
//                 fieldName: "Zoon_Code",
//                 label: "تقسيم النطاقات"
//               },
//               {
//                 type: "field",
//                 fieldName: "Comparison",
//                 label: "المطـابقـة"
//               },
//               {
//                 type: "field",
//                 fieldName: "Balady_2",
//                 label: "بلدي_2"
//               },
//               {
//                 type: "field",
//                 fieldName: "F3D",
//                 label: "الرسم_ثلاثي_الأبعاد"
//               }
//             ]
//           },
//   });

//   reactiveUtils.when(
//     () => this.mapService.mapView.stationary,
//     () => {
//       // Filter out and show only the visible features in the feature table.
//       featureTable.filterGeometry = this.mapService.mapView.extent;
//     },
//     {
//       initial: true
//     }
//   );

//   // Listen for the view's click event and access the associated graphic.

//   this.mapService.mapView.on("immediate-click", async (event) => {
//     const response = await this.mapService.mapView.hitTest(event);

//     this.candidate = response.results.find((result) => {

//       // debugger;
//       // return result.graphic && result.graphic.layer && result.graphic.layer === layer;
//     });

//     // Add the graphic's ObjectId into the collection of highlightIds.
//     // Check that the featureTable.highlightIds collection
//     // does not include an already highlighted feature.
//     if (this.candidate) {
//       const objectId = this.candidate.graphic.getObjectId();

//       if (featureTable.highlightIds.includes(objectId)) {
//         // Remove feature from current selection if feature
//         // is already added to highlightIds collection
//         featureTable.highlightIds.remove(objectId);
//       } else {
//         // Add this feature to the featureTable highlightIds collection
//         featureTable.highlightIds.add(objectId);
//       }
//     }
//   });

//   // Watch the featureTable's highlightIds.length property,
//   // and get the count of highlighted features within
//   // the table.

//   reactiveUtils.watch(
//     () => featureTable.highlightIds.length,
//     (highlightIdsCount) => {
//       // Iterate through the filters within the table.
//       // If the active filter is "Show selection",
//       // changes made to highlightIds (adding/removing)
//       // are reflected.

//       featureTable.viewModel.activeFilters.forEach((filter) => {
//         if (filter.type === "selection") {

//           // debugger;
//           // this.selectionIdCount = filter.objectIds.length; // the filtered selection's id count

//           // Check that the filter selection count is equal to the
//           // highlightIds collection count. If not, update filter selection.
//           if (this.selectionIdCount !== highlightIdsCount) {
//             featureTable.filterBySelection();
//           }
//         }
//       });
//     }
//   );
//   }) ;
// }

// createChart(canvasId: string, chartData,chartTitle: string, legendLabels: string[],filterFieldName: string) {//filterFieldName: string
//   const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
//   const that= this;
//   if (!canvas) {
//      console.error(`Canvas element with ID "${canvasId}" not found.`);
//      return;
//   }

//   if (Object.keys(chartData).length === 0) {
//      console.error(`No data available for chart "${canvasId}".`);
//      return;
//   }

//   new Chart(canvas, {
//      type: chartTitle=='Zoon_Code'?'bar':'doughnut',

//      data: {
//        labels:chartData.map(f=>f[chartTitle]),//) Object.keys(chartData), //labels: legendLabels,
//        datasets: [{
//          data: chartData.map(f=>f[chartTitle+'_C']),//Object.values(chartData),
//          label:chartTitle,
//          backgroundColor: [
//            'rgba(103, 58, 183, 0.6)',
//            'rgba(38, 166, 154, 0.6)',
//            'rgba(0, 77, 64, 0.6)',
//            'rgba(26, 35, 126, 0.6)',
//            'rgba(106, 27, 154, 0.6)',
//            'rgba(74, 20, 140, 0.6)'
//          ]
//         }]
//      },
//      options: {
//       responsive: true,

//       plugins: {
//         title: {
//           display: true,
//           text: chartTitle,

//         },
//         // legend: {
//         //   labels: {
//         //     boxWidth: 10,
//         //     padding: 15,
//         //     color: '#000',
//         //     font: {
//         //       family: 'Arial',
//         //       size: 16
//         //     }
//         //   }
//         // }
//       },
//       onClick(event, elements, chart) {
//         // debugger;
//         this.newChart=chart;
//         let selected=chart.tooltip.title[0];
//         let chartIndex=chart.id;
//         let selectedFilter;
//         if (chart.data.datasets[0].label=='BELEDIYE'){
//         this.selectedBaladeya = selected;
//         selectedFilter="BELEDIYE";
//       }
//       if(chart.data.datasets[0].label=='Zoon_Code'){
//         this.selectedZoneCode = selected;
//         selectedFilter="Zoon_Code";

//       }
//         that.selectFeatures(selected,chartIndex,selectedFilter);

//         // console.log(canvas.id)
//         // console.log(this.chartLayer)
//         console.log(chart.data.datasets[0].label)
//         // console.log(elements)
//         // console.log(chart.config.options.plugins.title.text)
//         console.log(selected);
//         console.log(chart.data.datasets);
//         console.log(this.selectedBaladeya);
//         console.log(this.selectedZoneCode);
//       },

//     }
// });

// }

// queryFilter(){
//   var indx = 0;
//   // if (!this.selectedBaladeya && !this.selectedZoneCode){
//   this.planFieldNames.forEach(((field)=>{
//     //debugger;
//      this.query = this.layer.createQuery();

//     const statisticDefinitions =  new StatisticDefinition({
//       onStatisticField: 'objectid',
//       outStatisticFieldName: field+'_C',
//       statisticType: 'count'
//     });

//      // Add filter conditions based on selected values
//      if (field === 'BELEDIYE' && this.selectedBaladeya) {
//       this.query.where = `BELEDIYE = '${this.selectedBaladeya}'`;
//     } else if (field === 'Zoon_Code' && this.selectedZoneCode) {
//       this.query.where = `Zoon_Code = '${this.selectedZoneCode}'`;
//     }

//     this.query.outStatistics = [statisticDefinitions];
//     this.query.returnGeometry = false;
//     //query.where = '1=1';
//     this.query.groupByFieldsForStatistics =  [field];

//     var that = this;
//   this.layer.queryFeatures(this.query).then(function (result)  {
//     //  debugger;

//     const features = result && result.features ? result.features : [];
//     // Process the retrieved features and create charts
//     // console.log('hello features');
//     // console.log(features);
//     indx++;
//     if (features) {
//       if (field != 'BELEDIYE' && !this.selectedBaladeya) {

//       } else if (field === 'Zoon_Code' && this.selectedZoneCode) {

//       }
//       this.newChart.delete();
//       that.createCharts(result, indx);

// console.log(features[0].attributes);
//       // this.createChart(canvasId, chartData, chartTitle, legendLabels,fieldName);

//     } else {
//       console.error('No features found.');
//     }
//   })
//   .catch(function (error)  {
//     console.error('Error fetching features:', error);
//   });
// }));
// }

// selectFeatures(selectedValue,canvasID,filterFieldName){
//   // debugger;
// const that=this;
//  let planFieldName= this.planFieldNames[canvasID];
// console.log(planFieldName);

// // Clear previous graphics
// this.mapService.mapView.graphics.removeAll();

// const planQuery = {
//   outFields: ["shape"],
//   where: planFieldName+"='"+ selectedValue+"'"
// };
// if (filterFieldName === "BELEDIYE") {
//   this.selectedBaladeya = selectedValue;
//   this.query.where = `BELEDIYE = '${selectedValue}'`;

// } else if (filterFieldName === "Zoon_Code") {
//   this.selectedZoneCode = selectedValue;
//   this.query.where = `Zoon_Code = '${selectedValue}'`;
// }
// //  else {
// //   planQuery.where =`${filterFieldName} = '${selectedValue}'`;// planFieldName+"='"+ selectedValue+"'";//`${filterFieldName} = '${selectedValue}'`;
// // }
// // this.selectFeatures(filterFieldName,this.planFieldNames[canvasID],selectedValue)

//   if (planFieldName){
// this.mapService.parBoundary.queryFeatures(planQuery).then(function(response){
//   // debugger;
//   const newSymbol = {
//     type: "simple-fill",
//     color: [77, 75, 202, 0.8],
//     outline: {
//       color: [255, 255, 255],
//       width: 1
//     }
//   };

//   // Create a new graphic for each feature in the response
//   const graphics = response.features.map(feature => {
//     return new Graphic({
//       geometry: feature.geometry,
//       symbol: newSymbol
//     });
//   });

//   // Add the graphics to the map
//   graphics.forEach(graphic =>

//    {
//     console.log(that);
//     return that.mapService.mapView.graphics.add(graphic);
//    }
//     );
// console.log(graphics.length);
//   // Zoom to the first graphic
//   if (graphics.length > 0) {
//     console.log(graphics[0]);
//     that.mapService.mapView.goTo(graphics);

//   }

// });

// }
// }
// }

// //-----------------to set on selectFeature--------------
// // if(this.selectedBaladeya){

// //   this.planFieldNames.forEach(((field)=>{
// //     //debugger;
// //     if (field!='BELEDIYE'&& field!='Zoon_Code'){
// //      var query = layer.createQuery();

// //     const statisticDefinitions =  new StatisticDefinition({
// //       onStatisticField: 'objectid',
// //       outStatisticFieldName: field+'_C',
// //       statisticType: 'count'
// //     });
// //     query.outStatistics = [statisticDefinitions];
// //     query.returnGeometry = false;
// //     query.where = `BELEDIYE = '${this.selectedBaladeya}'`;
// //     query.groupByFieldsForStatistics =  [field];

// //     var that = this;
// //   layer.queryFeatures(query).then(function (result)  {
// //      //debugger;
// //     let stats = result.features[0].attributes;
// //      console.log("output stats:", stats);
// //     const features = result && result.features ? result.features : [];
// //     // Process the retrieved features and create charts
// //     console.log('hello features');
// //     console.log(features);
// //     indx++;
// //     if (features) {
// //       that.createCharts(result, indx);
// //     } else {
// //       console.error('No features found.');
// //     }
// //   })
// //   .catch(function (error)  {
// //     console.error('Error fetching features:', error);
// //   });
// // }
// // }));
// // } else if(this.selectedZoneCode){

// //   this.planFieldNames.forEach(((field)=>{
// //     //debugger;
// //     if (field!='BELEDIYE'&& field!='Zoon_Code'){
// //      var query = layer.createQuery();

// //     const statisticDefinitions =  new StatisticDefinition({
// //       onStatisticField: 'objectid',
// //       outStatisticFieldName: field+'_C',
// //       statisticType: 'count'
// //     });
// //     query.outStatistics = [statisticDefinitions];
// //     query.returnGeometry = false;
// //     query.where = `Zoon_Code = '${this.selectedZoneCode}'`;
// //     query.groupByFieldsForStatistics =  [field];

// //     var that = this;
// //   layer.queryFeatures(query).then(function (result)  {
// //      //debugger;
// //     let stats = result.features[0].attributes;
// //      console.log("output stats:", stats);
// //     const features = result && result.features ? result.features : [];
// //     // Process the retrieved features and create charts
// //     console.log('hello features');
// //     console.log(features);
// //     indx++;
// //     if (features) {
// //       that.createCharts(result, indx);
// //     } else {
// //       console.error('No features found.');
// //     }
// //   })
// //   .catch(function (error)  {
// //     console.error('Error fetching features:', error);
// //   });
// // }
// // }));
// // }
// //-------------------end of edits for selectfeature---------------

// //--------------------------------------------------------------------------------------------------------------------

import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Chart } from 'chart.js/auto';
import { MapService } from '../../services/map.service';
import Graphic from '@arcgis/core/Graphic';
import FeatureTable from '@arcgis/core/widgets/FeatureTable';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import StatisticDefinition from '@arcgis/core/rest/support/StatisticDefinition';
import Query from '@arcgis/core/rest/support/Query';

@Component({
    selector: 'app-plan-dashboard',
    templateUrl: './plan-dashboard.component.html',
    styleUrl: './plan-dashboard.component.scss'
})
export class PlanDashboardComponent implements OnInit, AfterViewInit {
    public planFieldNames: any[];
    mainPlanFields: any[];
    selectionIdCount = 0; // The filtered selection id count
    candidate; // The graphic accessed via the view.click event
    selectedBaladeya: string = '';
    selectedZoneCode: string = '';
    query;
    mainQuery;
    layer;
    newChart = {};
    mainQuery2;

    // indx:number=0;
    constructor(
        private http: HttpClient,
        private mapService: MapService,
        private elementRef: ElementRef
    ) { }

    ngOnInit() {
        this.mainPlanFields = ['Zoon_Code', 'BELEDIYE'];
        this.planFieldNames = [
            'parcel_plane',
            'Correction_Parcel',
            'MadinahAerialPhotography_zone',
            'Comparison',
            'Plan_Correct',
            'Balady_2',
            'F3D'
        ];
        const url =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5';

        this.layer = new FeatureLayer({
            url: url
        });

        var mainIndx = 0;
        var indx = 2;
        this.mainPlanFields.forEach((field) => {
            this.mainQuery = this.layer.createQuery();
            const statisticDefinitions = new StatisticDefinition({
                onStatisticField: 'objectid',
                outStatisticFieldName: field + '_C',
                statisticType: 'count'
            });
            // Add filter conditions based on selected values
            // if (field === 'BELEDIYE' ) {  //&& this.selectedBaladeya
            //   this.mainQuery.where = `BELEDIYE = '${this.selectedBaladeya}'`;
            // } else if (field === 'Zoon_Code') {   // && this.selectedZoneCode
            //   this.mainQuery.where = `Zoon_Code = '${this.selectedZoneCode}'`;
            // }
            this.mainQuery.outStatistics = [statisticDefinitions];
            this.mainQuery.returnGeometry = false;
            this.mainQuery.groupByFieldsForStatistics = [field];
            var that = this;
            this.layer
                .queryFeatures(this.mainQuery)
                .then(function (result) {
                    //  debugger;
                    console.log(result);
                    // let stats = result.features[0].attributes;
                    //  console.log("output stats:", stats);
                    const features =
                        result && result.features ? result.features : [];
                    mainIndx++;

                    if (features) {
                        that.createMainCharts(result, mainIndx);
                        // console.log(features[0].attributes);
                    } else {
                        console.error('No features found.');
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching features:', error);
                });
        });

        // if (!this.selectedBaladeya && !this.selectedZoneCode){
        this.planFieldNames.forEach((field) => {
            //debugger;
            this.query = this.layer.createQuery();

            const statisticDefinitions = new StatisticDefinition({
                onStatisticField: 'objectid',
                outStatisticFieldName: field + '_C',
                statisticType: 'count'
            });

            this.query.outStatistics = [statisticDefinitions];
            this.query.returnGeometry = false;
            //query.where = '1=1';
            this.query.groupByFieldsForStatistics = [field];

            var that = this;
            this.layer
                .queryFeatures(this.query)
                .then(function (result) {
                    //  debugger;
                    console.log(result);
                    let stats = result.features[0].attributes;
                    console.log('output stats:', stats);
                    const features =
                        result && result.features ? result.features : [];
                    // Process the retrieved features and create charts
                    // console.log('hello features');
                    // console.log(features);
                    indx++;
                    if (features) {
                        that.createCharts(result, indx);

                        console.log(features[0].attributes);
                        // this.createChart(canvasId, chartData, chartTitle, legendLabels,fieldName);
                    } else {
                        console.error('No features found.');
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching features:', error);
                });
        });

        // }
    }

    // processFeatures(features, indx) {

    //   if (features) {
    //     // const fieldCounts = {};

    //     // features.forEach((feature) => {
    //     //   debugger;
    //     //   this.planFieldNames.forEach(function (fieldName)  {
    //     //     debugger;
    //     //     const fieldValue = feature.attributes[fieldName];
    //     //     if (!fieldCounts[fieldName]) {
    //     //       fieldCounts[fieldName] = {};
    //     //     }
    //     //     fieldCounts[fieldName][fieldValue] = (fieldCounts[fieldName][fieldValue] || 0) + 1;
    //     //   });
    //     // });

    //     // Create charts using fieldCounts object

    //     this.createCharts(features, indx);
    //   } else {
    //     console.error('No features found.');
    //   }
    // }

    createMainCharts(features: any, mainIndx) {
        features.fields.forEach((fieldName, index) => {
            console.log(features.features.map((f) => f.attributes));

            if (index == 0) {
                const canvasId = `MyChart${mainIndx}`;
                const chartData = features.features.map((f) => f.attributes); //fieldCounts[fieldName];
                const chartTitle = fieldName.name;
                const legendLabels = features.features.map(
                    (f) => f.attributes[fieldName.name]
                ); //Object.keys(chartData);
                // alert(canvasId);
                this.createChart(
                    canvasId,
                    chartData,
                    chartTitle,
                    legendLabels,
                    fieldName
                ); //fieldName
            }
        });
    }
    createCharts(features: any, indx) {
        features.fields.forEach((fieldName, index) => {
            console.log(features.features.map((f) => f.attributes));

            if (index == 0) {
                const canvasId = `MyChart${indx}`;
                const chartData = features.features.map((f) => f.attributes); //fieldCounts[fieldName];
                const chartTitle = fieldName.name;
                const legendLabels = features.features.map(
                    (f) => f.attributes[fieldName.name]
                ); //Object.keys(chartData);
                // alert(canvasId);
                this.createChart(
                    canvasId,
                    chartData,
                    chartTitle,
                    legendLabels,
                    fieldName
                ); //fieldName
            }
        });
    }

    ngAfterViewInit(): void {
        const url =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5';
        const fields = [
            'parcel_plane',
            'correction_Parcel',
            'MadinahAerialPhotography_zone',
            'Plan_Correct',
            'Zoon_Code',
            'Comparison',
            'Balady_2',
            'F3D',
            'BELEDIYE'
        ];

        this.createAttributeTable(url, fields);
    }

    createAttributeTable(url: string, fields: string[]) {
        const container =
            this.elementRef.nativeElement.querySelector('.attributeContent');

        const layer = new FeatureLayer({
            url: url,
            outFields: fields
        });

        this.mapService.mapView.when(() => {
            const featureTable = new FeatureTable({
                view: this.mapService.mapView, // Replace with your MapView instance
                layer: layer,
                container: container,
                visibleElements: {
                    // Autocast to VisibleElements
                    menuItems: {
                        clearSelection: true,
                        refreshData: true,
                        toggleColumns: true,
                        selectedRecordsShowAllToggle: true,
                        zoomToSelection: true
                    }
                },
                editingEnabled: true,
                tableTemplate: {
                    // autocast to TableTemplate
                    columnTemplates: [
                        // takes an array of GroupColumnTemplate and FieldColumnTemplate
                        // { // autocast to GroupColumnTemplate
                        // type: "group",
                        // label: "Parcel details",
                        // columnTemplates: [
                        {
                            type: 'field',
                            fieldName: 'OBJECTID',
                            label: 'OBJECTID'
                        },
                        {
                            type: 'field',
                            fieldName: 'parcel_plane',
                            label: 'رسم المخطط'
                        },
                        {
                            type: 'field',
                            fieldName: 'correction_Parcel',
                            label: 'تصحيح الأراضي'
                        },
                        {
                            type: 'field',
                            fieldName: 'MadinahAerialPhotography_zone',
                            label: 'مرحلة العمل بالتصوير الجوي'
                        },
                        {
                            type: 'field',
                            fieldName: 'Plan_Correct',
                            label: 'مرحلة تصحيح المخطط'
                        },
                        {
                            type: 'field',
                            fieldName: 'Zoon_Code',
                            label: 'تقسيم النطاقات'
                        },
                        {
                            type: 'field',
                            fieldName: 'Comparison',
                            label: 'المطـابقـة'
                        },
                        {
                            type: 'field',
                            fieldName: 'Balady_2',
                            label: 'بلدي_2'
                        },
                        {
                            type: 'field',
                            fieldName: 'F3D',
                            label: 'الرسم_ثلاثي_الأبعاد'
                        }
                    ]
                }
            });

            reactiveUtils.when(
                () => this.mapService.mapView.stationary,
                () => {
                    // Filter out and show only the visible features in the feature table.
                    featureTable.filterGeometry =
                        this.mapService.mapView.extent;
                },
                {
                    initial: true
                }
            );

            // Listen for the view's click event and access the associated graphic.

            this.mapService.mapView.on('immediate-click', async (event) => {
                const response = await this.mapService.mapView.hitTest(event);

                this.candidate = response.results.find((result) => {
                    // debugger;
                    // return result.graphic && result.graphic.layer && result.graphic.layer === layer;
                });

                // Add the graphic's ObjectId into the collection of highlightIds.
                // Check that the featureTable.highlightIds collection
                // does not include an already highlighted feature.
                if (this.candidate) {
                    const objectId = this.candidate.graphic.getObjectId();

                    if (featureTable.highlightIds.includes(objectId)) {
                        // Remove feature from current selection if feature
                        // is already added to highlightIds collection
                        featureTable.highlightIds.remove(objectId);
                    } else {
                        // Add this feature to the featureTable highlightIds collection
                        featureTable.highlightIds.add(objectId);
                    }
                }
            });

            // Watch the featureTable's highlightIds.length property,
            // and get the count of highlighted features within
            // the table.

            reactiveUtils.watch(
                () => featureTable.highlightIds.length,
                (highlightIdsCount) => {
                    // Iterate through the filters within the table.
                    // If the active filter is "Show selection",
                    // changes made to highlightIds (adding/removing)
                    // are reflected.

                    featureTable.viewModel.activeFilters.forEach((filter) => {
                        if (filter.type === 'selection') {
                            // debugger;
                            // this.selectionIdCount = filter.objectIds.length; // the filtered selection's id count

                            // Check that the filter selection count is equal to the
                            // highlightIds collection count. If not, update filter selection.
                            if (this.selectionIdCount !== highlightIdsCount) {
                                featureTable.filterBySelection();
                            }
                        }
                    });
                }
            );
        });
    }

    createChart(
        canvasId: string,
        chartData,
        chartTitle: string,
        legendLabels: string[],
        filterFieldName: string
    ) {
        //filterFieldName: string
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        const that = this;
        if (!canvas) {
            console.error(`Canvas element with ID "${canvasId}" not found.`);
            return;
        }

        if (Object.keys(chartData).length === 0) {
            console.error(`No data available for chart "${canvasId}".`);
            return;
        }

        var nChart = new Chart(canvas, {
            type: chartTitle == 'Zoon_Code' ? 'bar' : 'doughnut',

            data: {
                labels: chartData.map((f) => f[chartTitle]), //) Object.keys(chartData), //labels: legendLabels,
                datasets: [
                    {
                        data: chartData.map((f) => f[chartTitle + '_C']), //Object.values(chartData),
                        label: chartTitle,
                        backgroundColor: [
                            'rgba(103, 58, 183, 0.6)',
                            'rgba(38, 166, 154, 0.6)',
                            'rgba(0, 77, 64, 0.6)',
                            'rgba(26, 35, 126, 0.6)',
                            'rgba(106, 27, 154, 0.6)',
                            'rgba(74, 20, 140, 0.6)'
                        ]
                    }
                ]
            },
            options: {
                responsive: true,

                plugins: {
                    title: {
                        display: true,
                        text: chartTitle
                    }
                    // legend: {
                    //   labels: {
                    //     boxWidth: 10,
                    //     padding: 15,
                    //     color: '#000',
                    //     font: {
                    //       family: 'Arial',
                    //       size: 16
                    //     }
                    //   }
                    // }
                },
                onClick(event, elements, chart) {
                    // debugger;
                    let selected = chart.tooltip.title[0];
                    let chartIndex = chart.id;
                    let selectedFilter;
                    if (chart.data.datasets[0].label == 'BELEDIYE') {
                        this.selectedBaladeya = selected;
                        selectedFilter = 'BELEDIYE';
                        // this.query.where = `BELEDIYE = '${selected}'`;
                        // this.newChart.update();
                    }
                    if (chart.data.datasets[0].label == 'Zoon_Code') {
                        this.selectedZoneCode = selected;
                        selectedFilter = 'Zoon_Code';
                        // this.query.where = `Zoon_Code = '${selected}'`;
                        // this.newChart.update();
                    }
                    that.selectFeatures(selected, chartIndex, selectedFilter);

                    // console.log(chart.data.datasets[0].label)
                    // console.log(this.newChart.data.datasets[0].label)

                    console.log('selected', selected);
                    console.log(this.newChart);
                    // console.log(chart.data.datasets);
                    console.log('selectedBaladeya', this.selectedBaladeya);
                    console.log('selectedZoneCode', this.selectedZoneCode);
                    console.log('selectedFilter', selectedFilter);
                }
            }
        });
        this.newChart[canvasId] = nChart;
    }

    selectFeatures(selectedValue, canvasID, filterFieldName) {
        // debugger;
        const that = this;
        // let mainPlanField=this.mainPlanFields[canvasID];
        //  let planFieldName= this.planFieldNames[canvasID];
        // console.log(planFieldName);
        // console.log(mainPlanField);

        let selectedDomain = selectedValue;
        console.log(selectedDomain);
        console.log(filterFieldName);
        console.log(canvasID);

        if (filterFieldName == 'BELEDIYE' || filterFieldName == 'Zoon_Code') {
            var indx1 = 2;
            this.planFieldNames.forEach((field) => {
                //debugger;
                var query1 = this.layer.createQuery();

                const statisticDefinitions1 = new StatisticDefinition({
                    onStatisticField: 'objectid',
                    outStatisticFieldName: field + '_C',
                    statisticType: 'count'
                });

                query1.outStatistics = [statisticDefinitions1];
                query1.returnGeometry = false;
                // debugger
                if (filterFieldName === 'BELEDIYE') {
                    // this.selectedBaladeya = selectedDomain;
                    query1.where = `BELEDIYE = N'${selectedDomain}'`;
                } else if (filterFieldName === 'Zoon_Code') {
                    // this.selectedZoneCode = selectedValue;
                    query1.where = `Zoon_Code = '${selectedDomain}'`;
                }
                query1.groupByFieldsForStatistics = [field];

                var that = this;
                this.layer
                    .queryFeatures(query1)
                    .then(function (result) {
                        debugger;
                        console.log(result);

                        const features =
                            result && result.features ? result.features : [];

                        indx1++;
                        console.log(indx1);
                        if (features) {
                            console.log(features);
                            // debugger
                            // if(canvasID==0 || canvasID==1){

                            console.log(that.newChart);
                            // debugger;
                            that.newChart['MyChart' + indx1].destroy();

                            that.createCharts(result, indx1);
                            that.newChart['MyChart' + indx1].update();
                            // }
                        } else {
                            console.error('No features found.');
                        }
                    })
                    .catch(function (error) {
                        console.error('Error fetching features:', error);
                    });
            });
        }

        // Clear previous graphics
        // this.mapService.mapView.graphics.removeAll();

        // const planQuery = {
        //   outFields: ["shape"],
        //   where: planFieldName+"='"+ selectedValue+"'"
        // };
        // if (filterFieldName === "BELEDIYE") {
        //   this.selectedBaladeya = selectedValue;
        //   this.query.where = `BELEDIYE = '${selectedValue}'`;

        // } else if (filterFieldName === "Zoon_Code") {
        //   this.selectedZoneCode = selectedValue;
        //   this.query.where = `Zoon_Code = '${selectedValue}'`;
        // }

        // if(mainPlanField){
        //  var indx = 0;
        //   this.mainPlanFields.forEach(((field)=>{
        //     if (this.newChart) {
        //       // Destroy the existing Chart instance
        //       this.newChart.destroy();
        //     }
        //     this.mainQuery2=this.layer.createQuery();
        //     const statisticDefinitions =  new StatisticDefinition({
        //       onStatisticField: 'objectid',
        //       outStatisticFieldName: field+'_C',
        //       statisticType: 'count'
        //     });
        //   this.mainQuery2.outStatistics = [statisticDefinitions];
        //     this.mainQuery2.returnGeometry = false;
        //     this.mainQuery2.groupByFieldsForStatistics =  [field];
        //     var that = this;
        //     if (filterFieldName === "BELEDIYE") {
        //         this.selectedBaladeya = selectedValue;
        //         this.query.where = `BELEDIYE = '${selectedValue}'`;

        //       } else if (filterFieldName === "Zoon_Code") {
        //         this.selectedZoneCode = selectedValue;
        //         this.query.where = `Zoon_Code = '${selectedValue}'`;
        //       }
        //     this.layer.queryFeatures(this.mainQuery2).then(function (result)  {
        //    const features = result && result.features ? result.features : [];
        //       indx++;
        //       if (features) {
        //         // this.newChart.delete();
        //         that.createCharts(result, indx);
        //    } else {
        //         console.error('No features found.');
        //       }
        //     })
        //     .catch(function (error)  {
        //       console.error('Error fetching features:', error);
        //     });

        //   }));

        // }

        // //  else {
        // //   planQuery.where =`${filterFieldName} = '${selectedValue}'`;// planFieldName+"='"+ selectedValue+"'";//`${filterFieldName} = '${selectedValue}'`;
        // // }
        // // this.selectFeatures(filterFieldName,this.planFieldNames[canvasID],selectedValue)

        //   if (planFieldName){
        // this.mapService.parBoundary.queryFeatures(planQuery).then(function(response){
        //   // debugger;
        //   const newSymbol = {
        //     type: "simple-fill",
        //     color: [77, 75, 202, 0.8],
        //     outline: {
        //       color: [255, 255, 255],
        //       width: 1
        //     }
        //   };

        //   // Create a new graphic for each feature in the response
        //   const graphics = response.features.map(feature => {
        //     return new Graphic({
        //       geometry: feature.geometry,
        //       symbol: newSymbol
        //     });
        //   });

        //   // Add the graphics to the map
        //   graphics.forEach(graphic =>

        //    {
        //     console.log(that);
        //     return that.mapService.mapView.graphics.add(graphic);
        //    }
        //     );
        // console.log(graphics.length);
        //   // Zoom to the first graphic
        //   if (graphics.length > 0) {
        //     console.log(graphics[0]);
        //     that.mapService.mapView.goTo(graphics);

        //   }

        // });
        // }

        // }
    }
}
